import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute } from "@angular/router";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import LocalizationConstants from "src/app/constants/localization-constants";
import { ContractLine } from "src/app/models/ContractLine";
import { CompanyService } from "src/app/services/company.service";

import { ContractService } from "./../../services/contract.service";

@Component({
  selector: "app-contract-items",
  templateUrl: "./contract-items.component.html",
  styleUrls: ["./contract-items.component.scss"],
  standalone: false,
})
export class ContractItemsComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSource = new MatTableDataSource<ContractLine>([]);
  isLoading: boolean;
  faSpinner = faSpinner;
  contractRef: string;
  pageSize: number = 10;
  localizationConstants = LocalizationConstants;

  columns = [
    { key: "partNumber", title: LocalizationConstants.CONTRACT_ITEM_NUMBER },
    { key: "chargeType", title: LocalizationConstants.CONTRACT_ITEM_TYPE },
    {
      key: "description",
      title: LocalizationConstants.CONTRACT_ITEM_DESCRIPTION,
    },
    {
      key: "actualService",
      title: LocalizationConstants.CONTRACT_ITEM_ACTUAL_SERVICE,
    },
  ];

  columnKeys = this.columns.map((column) => column.key);

  constructor(
    public contractService: ContractService,
    public companyService: CompanyService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.contractRef = this.route.parent.snapshot.paramMap.get("contractReference");
    if (!this.companyService.selectedCompany?.name) return;
    this.getContractLines();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  getContractLines() {
    this.isLoading = true;
    this.contractService
      .getContractLines(this.companyService.selectedCompany.name, this.contractRef)
      .subscribe(
        (response) => {
          this.isLoading = false;
          if (!response) return;
          this.dataSource.data = response;
        },
        () => (this.isLoading = false),
      );
  }
}
